import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { useAuth } from '../contexts/AuthContext';
import { getClientInfo } from '../supabase';

const Analyzer = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingLabel, setLoadingLabel] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [userName, setUserName] = useState(null);

  // sessionId ya no es necesario, se eliminó

  // Cargar nombre del usuario desde Supabase
  useEffect(() => {
    const loadUserName = async () => {
      if (user?.email) {
        try {
          const clientInfo = await getClientInfo(user.email);
          if (clientInfo?.name) {
            setUserName(clientInfo.name);
          } else if (user.displayName) {
            setUserName(user.displayName);
          }
        } catch (error) {
          // Si falla, usar displayName de Firebase
          if (user.displayName) {
            setUserName(user.displayName);
          }
        }
      }
    };
    loadUserName();
  }, [user]);

  const isIdealistaInmuebleUrl = (candidate) => {
    if (typeof candidate !== 'string') return false;
    const trimmed = candidate.trim();
    const pattern = /^https?:\/\/(www\.)?idealista\.com\/inmueble\/\d+(?:[/#?].*)?$/i;
    return pattern.test(trimmed);
  };

  const handleGenerate = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!isIdealistaInmuebleUrl(url)) {
      setError("Por favor, introduce un enlace válido de Idealista (inmueble). Ej.: https://www.idealista.com/inmueble/108048216");
      return;
    }

    try {
      setLoading(true);
      setLoadingLabel("Generando informe...");
      const payload = {
        propertyUrl: url.trim(),
        userEmail: user?.email || null,
        userName: userName || user?.displayName || null
      };

      // URL del webhook de n8n para property reports
      // Forzar el uso de la URL correcta para evitar confusiones
      const webhookUrl = 'https://n8n.srv883685.hstgr.cloud/webhook/property-report';
      
      if (!webhookUrl) {
        throw new Error('URL del webhook no configurada');
      }

      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errText = await response.text().catch(() => '');
        const errorMessage = errText || `Error ${response.status} del servidor`;
        throw new Error(errorMessage);
      }

      // Intentar leer la respuesta
      await response.json().catch(() => null);
      
      setSuccess("¡Informe en proceso! El PDF se generará y estará disponible en tu dashboard en unos momentos.");
      setUrl(""); // Limpiar el campo después de enviar
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "No se pudo enviar el enlace. Inténtalo de nuevo más tarde.";
      setError(errorMessage);
    } finally {
      setLoading(false);
      setLoadingLabel("");
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="flex items-center justify-center min-h-screen pt-24">
        <div className="w-full max-w-2xl">
          <div className="glass rounded-3xl border border-primary/20 p-8 shadow-2xl">
            <h1 className="text-3xl font-bold mb-6">Generador de Informes</h1>
            <p className="text-muted-foreground mb-6">
              Pega un enlace de Idealista y genera un informe al instante.
            </p>
            <form className="flex flex-col sm:flex-row gap-3" onSubmit={handleGenerate}>
              <Input 
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://www.idealista.com/inmueble/..."
                className="flex-1"
              />
              <Button type="submit" variant="hero" disabled={loading}>
                Generar
              </Button>
            </form>

            {error && (
              <p className="text-sm text-red-600 mt-3">{error}</p>
            )}
            {success && (
              <div className="mt-3 p-4 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-sm text-green-800 mb-3">{success}</p>
                <Button
                  onClick={() => navigate('/dashboard')}
                  variant="hero"
                  size="sm"
                  className="w-full sm:w-auto"
                >
                  Ir al Dashboard
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>

      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="glass rounded-2xl border border-primary/30 p-6 w-[90%] max-w-sm text-center">
            <div className="mx-auto mb-3 w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
            <h2 className="text-lg font-semibold">{loadingLabel || "Procesando..."}</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Espera un momento mientras completamos el proceso.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Analyzer;
